import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { NoteResponse } from '../../../types/Note';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';

type UseGetAllNotesParams = {
  page?: number;
  per_page?: number;
  filters?: {
    noteable_uuid?: string;
    noteable_type?: string;
  };
};

export type UseGetAllNotesProps = {
  params?: UseGetAllNotesParams;
  enabled?: boolean;
};

export const fetchAllNotes = async ({ params }: UseGetAllNotesProps) => {
  const response = await CustomAxios.get<NoteResponse>(`/notes`, { params });
  const { data } = response;
  return data;
};

export function useGetAllNotes({ params, enabled = true }: UseGetAllNotesProps) {
  const queryKey: any = [queryKeys.allNotes, params];
  const query = useQuery({
    enabled,
    queryKey,
    queryFn: () => fetchAllNotes({ params }),
    placeholderData: keepPreviousData,
  });
  return query;
}
